import styled from '@emotion/styled'
import { colors, constants, screenSize } from '../../tokens'
import { Box, Button, FormControlLabel as MuiFormControlLabel, createTheme, css } from '@mui/material'
import Section from '../section'
import { Stack } from '@mui/system'
import Link from 'next/link'

export const darkTheme = createTheme({
  palette: { mode: 'dark' },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#90caf9 !important',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: colors.globalDarkBlueTransparent,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: '#90caf9',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          paddingTop: '4px',
          fontSize: '13px',
        },
      },
    },
  },
})

export const SMobileContainer = styled.div`
  ${screenSize.mobile(css`
    z-index: 1300;
    position: fixed;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
  `)}
  ${screenSize.large(css`
    display: none;
  `)}
`

export const SMobileButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1300;
  background-color: ${colors.globalDarkBlue};
  ${screenSize.large(css`
    display: none;
  `)}
`

export const SMobileDirectionButton = styled(Button)`
  width: 100%;
  height: ${constants.globalBufferMedium};
  background-color: ${colors.globalDarkBlue};
  color: ${colors.globalLightBlue};
  margin-top: -${constants.globalBufferXS};
  padding-bottom: 4px;
  padding-top: 2px;
  border-bottom: 1px solid ${colors.globalMediumBlue};
  &:hover {
    background-color: ${colors.globalDarkBlue};
  }
`

export const SDesktopContainer = styled(Section)`
  display: none;
  ${screenSize.large(css`
    display: block;
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    padding: 0;
    background-color: ${colors.globalDarkestBlue};
  `)}
`

export const SFilterActionsContainer = styled(Stack)`
  margin: ${constants.globalBufferXS} 0 0;
  flex: 1;
  color: #aaa;
  padding: ${constants.globalBufferSmall};
  ${screenSize.large(css`
    padding: ${constants.globalBufferMedium};
    margin: ${constants.globalBufferXS} 0 12px;
    flex-direction: row;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    & > * {
      margin-top: 0 !important;
    }
    & .MuiFormControl-root {
      margin: 0;
      padding-right: 20px;
      min-width: 200px;
    }
  `)}
`

export const SFormControlLabel = styled(MuiFormControlLabel)`
  height: 56px;
  padding: 14px;
  padding-left: 0;
  margin-top: 0;
`

export const SFilterButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  ${screenSize.mobile(css`
    width: 100%;
    justify-content: space-between;
    padding: ${constants.globalBufferMedium} 0;
  `)}
  ${screenSize.large(css`
    flex-direction: row-reverse;
  `)}
`

export const SPuller = styled(Box)`
  width: 100%;
  height: 6px;
  background-color: rgba(144, 202, 249, 0.25) !important;
  border-radius: 3;
  bottom: 8;
`
export const SEventFilterActionsContainer = styled(Stack)`
  margin: 0;
  flex: 1;
  color: #aaa;
  padding: ${constants.globalBufferSmall};
  ${screenSize.large(css`
    padding: ${constants.globalBufferMedium};
    margin: ${constants.globalBufferXS} 0 12px;
    flex-direction: row;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    & > * {
      margin-top: 0 !important;
    }
    & .MuiFormControl-root {
      margin: 0;
      padding-right: 20px;
      min-width: 240px;
    }
  `)}
`

export const SEventFilterButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  ${screenSize.mobile(css`
    width: 100%;

    justify-content: space-between;
  `)}
  ${screenSize.large(css`
    flex-direction: row-reverse;
  `)}
`

export const SHeaderLink = styled(Link)`
  color: white !important;
  text-decoration: none;
  & :visited,
  :active {
    color: white !important;
  }
`

export const SEventsMgmtFilterActionsContainer = styled(Stack)`
  margin: 0;
  flex: 1;
  color: #aaa;
  padding: ${constants.globalBufferSmall};
  ${screenSize.large(css`
    padding: ${constants.globalBufferMedium};
    margin: ${constants.globalBufferXS} 0 12px;
    flex-direction: row;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    & > * {
      margin-top: 0 !important;
    }
    & .MuiFormControl-root {
      margin: 0;
      padding-right: 20px;
      min-width: 240px;
    }
  `)}
`

export const SEventsMgmtFilterButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  ${screenSize.mobile(css`
    width: 100%;

    justify-content: space-between;
  `)}
  ${screenSize.large(css`
    flex-direction: row-reverse;
  `)}
`
